// processTopVideoPopupNotificationQueue.js
'use strict';
import {
  REMOVE_LIST_ITEMS,
  ADD_NOTIFICATIONS,
  REMOVE_NOTIFICATIONS,
} from '../ActionTypes.js';

import getListData from '../selector/getListData.js';
import getNotificationData from '../selector/getNotificationData.js';

import {
  STATUS_IDLE,
  STATUS_OPENING,
  STATUS_OPENED,
  STATUS_CLOSING,
} from '../resource/popupNotificationConstants.js';
import Delay from '../resource/Delay.js';

const delay = new Delay(400);

const TRANSITION_SECONDS = 0.4;
const DISPLAYED_SECONDS = 6;

/**
 * Process top video popup notification queue
 * @kind action
 * @return {Promise} Action promise.
 */
const processTopVideoPopupNotificationQueue =
  () => async (dispatch, getState) => {
    const itemIds =
      getListData(getState(), ['popupNotification', 'topVideo'], 'itemIds') ||
      [];
    const processingNotification = itemIds.find(id => {
      const status = getNotificationData(getState(), id, 'status');
      return [STATUS_OPENING, STATUS_OPENED, STATUS_CLOSING].includes(status);
    });
    if (!itemIds.length || processingNotification) {
      return dispatch({ type: '' });
    }
    const idleNotificationId = itemIds.find(
      id => STATUS_IDLE === getNotificationData(getState(), id, 'status')
    );
    dispatch({
      type: ADD_NOTIFICATIONS,
      payload: {
        notifications: {
          [idleNotificationId]: {
            status: STATUS_OPENING,
          },
        },
      },
    });
    await new Delay(TRANSITION_SECONDS * 1000).promise();
    dispatch({
      type: ADD_NOTIFICATIONS,
      payload: {
        notifications: {
          [idleNotificationId]: {
            status: STATUS_OPENED,
          },
        },
      },
    });
    await delay.promise(DISPLAYED_SECONDS * 1000);
    dispatch({
      type: ADD_NOTIFICATIONS,
      payload: {
        notifications: {
          [idleNotificationId]: {
            status: STATUS_CLOSING,
          },
        },
      },
    });
    await delay.promise(TRANSITION_SECONDS * 1000);
    dispatch({
      type: REMOVE_LIST_ITEMS,
      payload: {
        selectPath: ['popupNotification', 'topVideo'],
        itemIds: [idleNotificationId],
      },
    });
    dispatch({
      type: REMOVE_NOTIFICATIONS,
      payload: {
        itemIds: [idleNotificationId],
      },
    });
    return dispatch(processTopVideoPopupNotificationQueue());
  };

export default processTopVideoPopupNotificationQueue;
